import axios from 'axios';

const authService = process.env.REACT_APP_AUTH_SERVICE;

const Token = {
  // eslint-disable-next-line camelcase
  refreshToken: (refresh_token) => new Promise((resolve, reject) => {
    axios.post(`${authService}/token/refresh`, {}, {
      headers: {
        'x-access-refresh-token': refresh_token,
      },
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),
};

export default Token;
